import { Theme, makeStyles } from "@material-ui/core/styles";
import { MouseEventHandler, useRef } from "react";
import { CountryFlag } from "../../../../../../County/CountryFlag";
import { openOtherUserPanel } from "../../../../../../User/OtherUserPanel/functions";
import { UserForRanking } from "../../../../../../User/types";

export function UserNameAndTime({
    postedUser,
    minutesAgo,
    hideLevelAndCountry,
    hideTime,
}: {
    postedUser: UserForRanking;
    minutesAgo: number;
    hideLevelAndCountry?: boolean;
    hideTime?: boolean;
}) {
    const c = useStyles({ hideTime });

    const openUserDetail: MouseEventHandler<HTMLSpanElement> = ev => {
        ev.stopPropagation();
        openOtherUserPanel(postedUser.userId);
    };

    const flagContainerRef = useRef<HTMLDivElement>(null);

    return (
        <div className={c.container}>
            <div className={c.nameAndLevel} ref={flagContainerRef}>
                {!hideLevelAndCountry && (
                    <CountryFlag
                        code={postedUser.countryCode}
                        className={c.countryFlag}
                        onClick={openUserDetail}
                        containerRef={flagContainerRef}
                    />
                )}

                <span className={c.name} onClick={openUserDetail}>
                    {postedUser.name}
                </span>

                {!hideLevelAndCountry && (
                    <span className={c.level}>Lv. {postedUser?.level}</span>
                )}
            </div>

            <div className={c.time}>{getSocialPostTime(minutesAgo)}</div>
        </div>
    );
}
const useStyles = makeStyles<Theme, { hideTime?: boolean }>(theme => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
    },
    nameAndLevel: {
        borderBottom: "solid",
        borderBottomColor: theme.palette.grey[100],
        borderBottomWidth: 1,
        width: "100%",
        paddingBottom: 3,
    },
    countryFlag: { marginRight: 10, cursor: "pointer" },
    name: {
        fontWeight: "bold",
        fontSize: 20,
        wordBreak: "break-all",
        marginRight: 10,
        cursor: "pointer",
    },
    level: {
        color: theme.palette.grey[500],
        width: 40,
        fontWeight: "normal",
        fontSize: "small",
        marginRight: 20,
        whiteSpace: "nowrap",
    },
    time: ({ hideTime }) => ({
        opacity: hideTime ? 0 : 1,
        transition: "all 2000ms",
        color: theme.palette.grey[700],
    }),
}));

export function getSocialPostTime(minutesAgo: number): string {
    if (minutesAgo < 1) {
        return "now";
    }
    const hour = Math.floor(minutesAgo / 60);
    if (hour < 1) {
        return `${minutesAgo}m`;
    }
    const day = Math.floor(minutesAgo / (60 * 24));
    if (day < 1) {
        return `${hour}h`;
    }
    if (day < 30) {
        return `${day}d`;
    }
    const formatter = new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
    return formatter.format(new Date(Date.now() - minutesAgo * 60 * 1000));
}
